/** Makes a whole card clickable and keyboard-openable; inert while its title is being renamed. */
export const openableProps = (onOpen, isRenaming) =>
	onOpen && !isRenaming
		? {
				role: 'link',
				tabIndex: 0,
				onClick: onOpen,
				onKeyDown: (e) => {
					if (e.key === 'Enter' && e.target === e.currentTarget) onOpen();
				},
			}
		: {};
